// import { createGlobalStyle } from 'styled-components';

// import 'react-toastify/dist/ReactToastify.css';

// export default createGlobalStyle`

//   /**
//    * =====================================================================
//    * MÉTRICAS DE LAYOUT (densidade da interface)
//    * ---------------------------------------------------------------------
//    * Centraliza as alturas do "chrome" da aplicação (header, paddings do
//    * conteúdo e footer) que antes estavam replicadas em vários
//    * "calc(100vh - Xpx)" espalhados pelas telas.
//    *
//    * --app-chrome-h é o total consumido fora da área útil. As telas devem
//    * usar "calc(100vh - var(--app-chrome-h))" em vez de números fixos.
//    *
//    * O bloco @media reduz a densidade em tablets / telas de baixa altura
//    * (referência: 1340 x 800), liberando espaço vertical e horizontal para
//    * o desenho da peça e a tabela de itens.
//    * =====================================================================
//    */
//   /**
//    * ===== PWA: área segura do aparelho =====
//    * Com o app instalado na tela inicial não existe barra do navegador e o
//    * conteúdo ocupa a tela inteira, inclusive por baixo do notch e da
//    * barra de status. As variáveis abaixo expõem os recuos seguros e valem
//    * 0px quando o app roda dentro do navegador.
//    *
//    * Dependem de "viewport-fit=cover" na meta viewport do index.html.
//    */
//   :root {
//     --safe-top: env(safe-area-inset-top, 0px);
//     --safe-bottom: env(safe-area-inset-bottom, 0px);
//     --safe-left: env(safe-area-inset-left, 0px);
//     --safe-right: env(safe-area-inset-right, 0px);
//   }

//   :root {
//     --app-header-h: 76px;
//     --app-content-pad-y: 20px;
//     --app-content-pad-x: 40px;
//     --app-footer-h: 46px;

//     --app-chrome-h: calc(
//       var(--app-header-h) + (var(--app-content-pad-y) * 2) + var(--app-footer-h)
//     );

//     /** barra de título do catálogo e toolbar do desenho */
//     --cat-titlebar-h: 58px;
//     --cat-toolbar-h: 60px;

//     /** trilho (colapsado) e painel (aberto) das colunas laterais */
//     --cat-rail-w: 46px;
//     --cat-panel-w: 330px;

//     /** altura da área de rolagem da tabela de itens */
//     --cat-itens-h: 200px;

//     /**
//      * Largura da barra de rolagem (mesmo valor de ::-webkit-scrollbar).
//      * Usada para alinhar o cabeçalho da tabela de itens com o corpo,
//      * que rola dentro do tbody.
//      */
//     --cat-scrollbar-w: 8px;

//     /**
//      * ===== Tela de Mapeamento (EditorAI) =====
//      * Cromo próprio da tela: a barra de título do processo mais os recuos
//      * verticais do cartão branco. Somado a --app-chrome-h, dá a altura de
//      * viewport da área de trabalho do desenho — usar
//      * "calc(100vh - var(--edt-chrome-h))" em vez de número fixo.
//      */
//     --edt-titlebar-h: 58px;
//     --edt-card-pad-y: 10px;
//     --edt-chrome-h: calc(
//       var(--app-chrome-h) + var(--edt-titlebar-h) +
//         (var(--edt-card-pad-y) * 2)
//     );
//   }

//   /** Tablets / notebooks de baixa altura - ex.: 1340 x 800 */
//   @media (max-width: 1440px), (max-height: 900px) {
//     :root {
//       --app-header-h: 54px;
//       --app-content-pad-y: 8px;
//       --app-content-pad-x: 16px;
//       --app-footer-h: 0px;

//       --cat-titlebar-h: 48px;
//       --cat-toolbar-h: 44px;

//       --cat-rail-w: 44px;
//       --cat-panel-w: 320px;

//       --cat-itens-h: 168px;

//       --edt-titlebar-h: 48px;
//       --edt-card-pad-y: 6px;
//     }
//   }

//   /** Telas muito baixas - prioriza o desenho */
//   @media (max-height: 720px) {
//     :root {
//       --cat-itens-h: 132px;
//     }
//   }

//   * {
//     margin: 0;
//     padding: 0;
//     outline: 0;
//     box-sizing: border-box;

//     /** scrollbar para firefox */
//     scrollbar-width: thin;
//     scrollbar-color: rgba(121, 134, 158, 0.55) transparent;
//   }

//   *:focus {
//     outline: 0;
//   }

//   ::-webkit-scrollbar {
//     width: 8px;
//     height: 8px;
//   }

//   ::-webkit-scrollbar-track {
//     background: rgba(216, 224, 235, 0.45);
//     border-radius: 8px;
//   }

//   ::-webkit-scrollbar-thumb {
//     background: rgba(121, 134, 158, 0.55);
//     border-radius: 8px;
//   }

//   ::-webkit-scrollbar-thumb:hover {
//     background: rgba(121, 134, 158, 0.85);
//   }

//   html, body, #app-root {
//     display: flex;
//     height: 100%;
//     max-height: 100vh;
//     width: 100%;

//     /* Desabilita a seleção de texto em toda a plataforma */
//     user-select: none;
//   }

//   body {
//     -webkit-font-smoothing: antialiased;
//   }

//   body, input, textarea, button {
//     font: 14px 'Roboto', sans-serif;
//   }

//   input::-webkit-outer-spin-button,
//   input::-webkit-inner-spin-button {
//     -webkit-appearance: none;
//     margin: 0;
//   }

//   input[type=number] {
//     appearance: textfield;
//     -moz-appearance: textfield;
//   }

//   h1, h2, h3, h4, h5, h6 {
//     color: ${(props) => props.theme.color};
//     font-family: 'Rubik', sans-serif;
//   }

//   a {
//     text-decoration: none;
//   }

//   ul {
//     list-style: none;
//   }

//   button {
//     cursor: pointer;
//   }

//   /* AsyncSelect styles */
//   #black-bold-async-select {
//     color: #09090b;
//     font-size: 16px;
//     font-style: normal;
//   }

//   #grey-bold-async-select {
//     color: #27272a;
//     font-size: 14px;
//   }

//   #grey-italic-async-select {
//     color: #71717a;
//     font-size: 12px;
//     font-style: italic;
//   }

//   #img-async-select {
//     width: 80px;
//     height: 80px;
//     margin-right: 5px;
//     object-fit: cover;
//     border-radius: 5px;
//     box-shadow: 0px 3px 6px rgba(0,0,0,0.1);
//   }

//   .container-async-select {
//     display: flex;
//     align-items: center;
//     position: relative;
//   }

//   .hover-container-async-select {
//     position: relative;
//     display: inline-block;
//     transition-delay: 2.5s visibility;
//   }

//   .hover-container-async-select .hover-image-async-select {
//     visibility: hidden;
//     transition-delay: 0.5s;
//     position: absolute;
//     width: 350px;
//     height: 350px;
//     top: -50%;
//     left: -300%;
//     /* box-shadow: -5px -5px 6px rgba(0,0,0,0.1); */
//     box-shadow: 0px 3px 6px rgba(0,0,0,0.25);
//     border: 2px solid #e4e4e7;
//     border-radius: 5px;
//     z-index: 1000;
//     margin-left: 60px;
//   }

//   .hover-container-async-select:hover .hover-image-async-select {
//     visibility: visible;
//   }

// `;

import { createGlobalStyle } from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`

  /**
   * =====================================================================
   * MÉTRICAS DE LAYOUT (densidade da interface)
   * ---------------------------------------------------------------------
   * Centraliza as alturas do "chrome" da aplicação (header, paddings do
   * conteúdo e footer) que antes estavam replicadas em vários
   * "calc(100vh - Xpx)" espalhados pelas telas.
   *
   * --app-chrome-h é o total consumido fora da área útil. As telas devem
   * usar "calc(100vh - var(--app-chrome-h))" em vez de números fixos.
   *
   * O bloco @media reduz a densidade em tablets / telas de baixa altura
   * (referência: 1340 x 800), liberando espaço vertical e horizontal para
   * o desenho da peça e a tabela de itens.
   * =====================================================================
   */
  /**
   * ===== PWA: área segura do aparelho =====
   * Com o app instalado na tela inicial não existe barra do navegador e o
   * conteúdo ocupa a tela inteira, inclusive por baixo do notch e da
   * barra de status. As variáveis abaixo expõem os recuos seguros e valem
   * 0px quando o app roda dentro do navegador.
   *
   * Dependem de "viewport-fit=cover" na meta viewport do index.html.
   */
  :root {
    --safe-top: env(safe-area-inset-top, 0px);
    --safe-bottom: env(safe-area-inset-bottom, 0px);
    --safe-left: env(safe-area-inset-left, 0px);
    --safe-right: env(safe-area-inset-right, 0px);
  }

  :root {
    --app-header-h: 76px;
    --app-content-pad-y: 20px;
    --app-content-pad-x: 40px;
    --app-footer-h: 46px;

    --app-chrome-h: calc(
      var(--app-header-h) + (var(--app-content-pad-y) * 2) + var(--app-footer-h)
    );

    /** barra de título do catálogo e toolbar do desenho */
    --cat-titlebar-h: 58px;
    --cat-toolbar-h: 60px;

    /** trilho (colapsado) e painel (aberto) das colunas laterais */
    --cat-rail-w: 46px;
    --cat-panel-w: 330px;

    /** altura da área de rolagem da tabela de itens */
    --cat-itens-h: 200px;

    /**
     * Largura da barra de rolagem (mesmo valor de ::-webkit-scrollbar).
     * Usada para alinhar o cabeçalho da tabela de itens com o corpo,
     * que rola dentro do tbody.
     */
    --cat-scrollbar-w: 8px;

    /**
     * ===== Tela de Mapeamento (EditorAI) =====
     * Cromo próprio da tela: a barra de título do processo mais os recuos
     * verticais do cartão branco. Somado a --app-chrome-h, dá a altura de
     * viewport da área de trabalho do desenho — usar
     * "calc(100vh - var(--edt-chrome-h))" em vez de número fixo.
     */
    /**
     * A barra de título das telas do editor usa a versão compacta
     * (TitleBar compacto): título menor, sem recuo vertical e botões de
     * navegação reduzidos. O espaço economizado vai para o desenho.
     */
    --edt-titlebar-h: 40px;
    --edt-card-pad-y: 10px;
    --edt-chrome-h: calc(
      var(--app-chrome-h) + var(--edt-titlebar-h) +
        (var(--edt-card-pad-y) * 2)
    );
  }

  /** Tablets / notebooks de baixa altura - ex.: 1340 x 800 */
  @media (max-width: 1440px), (max-height: 900px) {
    :root {
      --app-header-h: 54px;
      --app-content-pad-y: 8px;
      --app-content-pad-x: 16px;
      --app-footer-h: 0px;

      --cat-titlebar-h: 48px;
      --cat-toolbar-h: 44px;

      --cat-rail-w: 44px;
      --cat-panel-w: 320px;

      --cat-itens-h: 168px;

      --edt-titlebar-h: 36px;
      --edt-card-pad-y: 6px;
    }
  }

  /** Telas muito baixas - prioriza o desenho */
  @media (max-height: 720px) {
    :root {
      --cat-itens-h: 132px;
    }
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;

    /** scrollbar para firefox */
    scrollbar-width: thin;
    scrollbar-color: rgba(121, 134, 158, 0.55) transparent;
  }

  *:focus {
    outline: 0;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(216, 224, 235, 0.45);
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(121, 134, 158, 0.55);
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(121, 134, 158, 0.85);
  }

  html, body, #app-root {
    display: flex;
    height: 100%;         
    max-height: 100vh;
    width: 100%;  

    /* Desabilita a seleção de texto em toda a plataforma */
    user-select: none;  
  }
  
  body {
    -webkit-font-smoothing: antialiased;
  }
  
  body, input, textarea, button {
    font: 14px 'Roboto', sans-serif;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  input[type=number] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${(props) => props.theme.color};
    font-family: 'Rubik', sans-serif;    
  }
  
  a {
    text-decoration: none;
  }
  
  ul {
    list-style: none;
  }
  
  button {
    cursor: pointer;
  }

  /* AsyncSelect styles */
  #black-bold-async-select {
    color: #09090b;
    font-size: 16px;
    font-style: normal;
  }

  #grey-bold-async-select {
    color: #27272a;
    font-size: 14px;
  }

  #grey-italic-async-select {
    color: #71717a;
    font-size: 12px;
    font-style: italic;
  }

  #img-async-select {
    width: 80px;
    height: 80px;
    margin-right: 5px;
    object-fit: cover;
    border-radius: 5px;
    box-shadow: 0px 3px 6px rgba(0,0,0,0.1);
  }

  .container-async-select {
    display: flex;
    align-items: center;
    position: relative;
  }

  .hover-container-async-select {
    position: relative;
    display: inline-block;
    transition-delay: 2.5s visibility;
  }

  .hover-container-async-select .hover-image-async-select {
    visibility: hidden;
    transition-delay: 0.5s;
    position: absolute;
    width: 350px;
    height: 350px;
    top: -50%;
    left: -300%;
    /* box-shadow: -5px -5px 6px rgba(0,0,0,0.1); */
    box-shadow: 0px 3px 6px rgba(0,0,0,0.25);
    border: 2px solid #e4e4e7;
    border-radius: 5px;
    z-index: 1000;
    margin-left: 60px;
  }

  .hover-container-async-select:hover .hover-image-async-select {
    visibility: visible;
  }

`;
